module.exports = __webpack_public_path__ + "static/media/Footer Logo 3.1f984f4b.png";